//////////////////////////////////////////////////////////////////////////////
// Automatically generated by running JavascriptCodeGenerator.exe
//////////////////////////////////////////////////////////////////////////////

export const MagstimColor = {
	AlarmHighBackground: '#ff0000',
	AlarmHighText: '#ffffff',
	AlarmLowBackground: '#00ffff',
	AlarmLowText: '#000000',
	AlarmMediumBackground: '#ffff00',
	AlarmMediumBText: '#000000',
	AlarmNotificationBackground: '#ffffff',
	AlarmNotificationText: '#000000',
	MagstimBlack: '#000000',
	MagstimButtonDisabled: '#dedede',
	MagstimButtonText: '#ffffff',
	MagstimCardHeaderBackground: '#cccccc',
	MagstimClear: 'rgba(255, 255, 255, 0)',
	MagstimComboBoxBackground: '#4a4a4a',
	MagstimComboBoxButton: '#6d6d6d',
	MagstimComboBoxForground: '#ffffff',
	MagstimcTextBoxHintText: '#999999',
	MagstimDarkGrey: '#141414',
	MagstimDarkNavy: '#1e1842',
	MagstimDarkOrange: '#ff4200',
	MagstimDeviceControlButtonArm: '#ff9900',
	MagstimDeviceControlButtonBackground: '#2f2f2f',
	MagstimDeviceControlButtonDisabled: '#4a4a4a',
	MagstimDeviceControlButtonDisarm: '#ff4747',
	MagstimDeviceControlButtonFire: '#88bb00',
	MagstimDeviceProgressArmed: '#88bb00',
	MagstimDeviceProgressArming: '#88bb00',
	MagstimDeviceProgressDisconnected: '#ff4747',
	MagstimDeviceProgressError: '#ff4747',
	MagstimDeviceProgressReady: '#88bb00',
	MagstimDeviceProgressRunning: '#88bb00',
	MagstimDeviceProgressStopped: '#00aeef',
	MagstimDeviceProgressWaiting: '#ff9900',
	MagstimDeviceProgressWarning: '#ff4200',
	MagstimDeviceStatusBarArmed: '#88bb00',
	MagstimDeviceStatusBarArming: '#88bb00',
	MagstimDeviceStatusBarBottomBackground: '#2f2f2f',
	MagstimDeviceStatusBarDisconnected: '#ff4747',
	MagstimDeviceStatusBarError: '#ff4747',
	MagstimDeviceStatusBarIconBackground: '#6d6d6d',
	MagstimDeviceStatusBarItemBackground: '#4a4a4a',
	MagstimDeviceStatusBarItemForeground: '#ffffff',
	MagstimDeviceStatusBarReady: '#88bb00',
	MagstimDeviceStatusBarRunning: '#88bb00',
	MagstimDeviceStatusBarStopped: '#ff4747',
	MagstimDeviceStatusBarTopBackground: '#cccccc',
	MagstimDeviceStatusBarTopForeground: '#2b2d6c',
	MagstimDeviceStatusBarWaiting: '#ff9900',
	MagstimDeviceStatusBarWarning: '#ff4200',
	MagstimError: '#ff4747',
	MagstimFadeBackground: 'rgba(102, 102, 102, 0.9019608)',
	MagstimGold: '#827941',
	MagstimGreen: '#88bb00',
	MagstimGrey102: '#666666',
	MagstimGrey109: '#6d6d6d',
	MagstimGrey153: '#999999',
	MagstimGrey35: '#232323',
	MagstimGrey47: '#2f2f2f',
	MagstimGrey74: '#4a4a4a',
	MagstimGroupBackground: '#2f2f2f',
	MagstimGroupContentContainerBackground: '#2f2f2f',
	MagstimGroupContentContainerForground: '#1e1842',
	MagstimGroupContentContainerHeader: '#cccccc',
	MagstimGroupHeaderText: '#1e1842',
	MagstimHeader: '#ffffff',
	MagstimInformation: '#88bb00',
	MagstimLabelBackground: 'rgba(255, 255, 255, 0)',
	MagstimLabelForground: '#ffffff',
	MagstimLightBlue: '#00aeef',
	MagstimLightGrey: '#cccccc',
	MagstimLightOrange: '#ff9900',
	MagstimMainHeaderBackground: '#ffffff',
	MagstimMainHeaderForground: '#2b2d6c',
	MagstimMainScreenBackground: '#141414',
	MagstimMessageBoxBackground: '#2f2f2f',
	MagstimMessageBoxForground: '#ffffff',
	MagstimMessageBoxHeaderBackground: '#141414',
	MagstimMessageBoxHeaderForeground: '#ffffff',
	MagstimNavy: '#2b2d6c',
	MagstimPositiveButton: '#00aeef',
	MagstimPrimary: '#00aeef',
	MagstimPrimaryBlue: '#00aeef',
	MagstimPrimaryButton: '#00aeef',
	MagstimProgressBackgroundDark: '#6d6d6d',
	MagstimProgressBackgroundLight: '#ececec',
	MagstimPropertyListBackground: 'rgba(255, 255, 255, 0)',
	MagstimPropertyListForground: '#ffffff',
	MagstimPurple: '#7c549e',
	MagstimQuestion: '#88bb00',
	MagstimRed: '#ff4747',
	MagstimResponseProgressControlBackground: '#6d6d6d',
	MagstimRotaryControlBackground: '#6d6d6d',
	MagstimRotaryControlButton: '#00aeef',
	MagstimRotaryControlForeground: '#ffffff',
	MagstimRotaryControlPressed: '#cccccc',
	MagstimRotaryControlSecondaryBackground: '#2f2f2f',
	MagstimSecondaryButton: '#6d6d6d',
	MagstimSideMenuBackground: '#2f2f2f',
	MagstimSideMenuForground: '#999999',
	MagstimSideMenuSelected: '#00aeef',
	MagstimSimpleContentContainerBackground: '#141414',
	MagstimSimpleContentContainerForground: '#ffffff',
	MagstimSimpleContentContainerUnderline: '#cccccc',
	MagstimTabSelected: '#00aeef',
	MagstimTabUnselected: '#cccccc',
	MagstimTertiaryButton: '#2b2d6c',
	MagstimTextBackground: '#4a4a4a',
	MagstimTextForground: '#ffffff',
	MagstimWarning: '#ffe558',
	MagstimWarningYellow: '#ffe558',
	MagstimWhite: '#ffffff',
	MagstimYellow: '#ffe558',
	TemperatureBlock1: '#1a529e',
	TemperatureBlock10: '#be0010',
	TemperatureBlock2: '#1188c2',
	TemperatureBlock3: '#2fb7ef',
	TemperatureBlock4: '#5cb9bb',
	TemperatureBlock5: '#4baa7f',
	TemperatureBlock6: '#96b603',
	TemperatureBlock7: '#cdc000',
	TemperatureBlock8: '#c58600',
	TemperatureBlock9: '#c1500a',
	TemperatureLevel01: '#be0010',
	TemperatureLevel02: '#c1500a',
	TemperatureLevel03: '#c58600',
	TemperatureLevel04: '#cdc000',
	TemperatureLevel05: '#96b603',
	TemperatureLevel06: '#4baa7f',
	TemperatureLevel07: '#5cb9bb',
	TemperatureLevel08: '#2fb7ef',
	TemperatureLevel09: '#1188c2',
	TemperatureLevel10: '#1a529e',
}
